import { render, staticRenderFns } from "./TaskDetailScreen.vue?vue&type=template&id=d79b40c4&scoped=true"
import script from "./TaskDetailScreen.vue?vue&type=script&lang=js"
export * from "./TaskDetailScreen.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailScreen.vue?vue&type=style&index=0&id=d79b40c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79b40c4",
  null
  
)

export default component.exports